import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import './footer.css';

function FooterLogo() {
  return (
    <StaticQuery
      query={graphql`
        query {
          placeholderImage: file(
            relativePath: { eq: "horticulture/logo-bsp.png" }
          ) {
            childImageSharp {
              fluid(maxWidth: 150) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={(data) => (
        <Img
          style={{ maxWidth: 50, maxHeight: 30, margin: '0 auto' }}
          fluid={data.placeholderImage.childImageSharp.fluid}
        />
      )}
    />
  );
}

export default function Footer() {
  return (
    <footer className="footer">
      <span>©Copyright MMXVIII W.A. Benjamin Electric All Rights Reserved</span>
      <nav style={{ width: '100%' }}>
        <a href="/">
          <FooterLogo />
        </a>
      </nav>
    </footer>
  );
}
